import * as React from "react";
import styled from "styled-components";

const Button = styled.button`
  outline: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
`;

const FakeLink: React.FC<React.ComponentPropsWithoutRef<"button">> = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>;
};

export default FakeLink;
